import { AxiosRequestConfig } from 'axios'
import {
  PermissionsGroup as Data,
  PermissionsGroupCollection as Collection,
} from '@/typings/api/PermissionsGroup'
import {
  BaseApiResponse, BaseApiResponseCollection as BRC,
} from '@/typings/common'

import { BaseApiAuth } from '@/api/BaseApiAuth'


export class PermissionsGroupsApi extends BaseApiAuth<Data, Collection> {
  protected readonly endpoint = 'permissions/groups';

  public copy<R = BaseApiResponse<Data>>(
    id: Data['id'],
    params: Record<string, unknown> = {},
    config: AxiosRequestConfig = {},
  ) {
    const path = `${id}/copy/`
    const [url] = this.getUrl(path, params)
    return this.request<never, R>('POST', url, { params, ...config })
  }

  public uploadPermissions(file: File, config: AxiosRequestConfig = {}) {
    const path = 'upload/'
    const [url] = this.getUrl(path)
    const data = new FormData()
    data.append('file', file)
    return this.request<never, BRC<string>>('POST', url, { data, ...config })
  }

  public downloadTemplateuUploadPermissionsURL() {
    const path = 'download_template/'
    const [url] = this.getUrl(path)
    return url
  }
}
